
import { useEffect } from "react";

import "./Program.css";
import "../Home/Components/attributes/Attributes.css"

import Navbar from "../Navbar/Navbar";
import Footer from "../Home/Components/footer/Footer";

const ElementaryProgram = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
    }, []);

    return (<>

        <Navbar />

        <div className="about-main">

            <div className="about-sec-1">

                <div className="about-s2-1">
                    <h1 style={{ fontSize: "35px" }}>The Elementary Montessori Programme <br/> <span>(Ages 6 – 12 years)</span></h1>
                    <div>
                        <p style={{ fontWeight: "600", lineHeight: "30px", marginBottom: "50px", textAlign: "justify" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>The Elementary Programme</span> ignites the child’s curiosity and reasoning by connecting learning to the big picture of life and the universe. Through hands-on projects and collaborative exploration, children develop critical thinking, creativity, and a strong moral compass. They gain freedom to discover their passions.</p>
                        <p style={{ fontWeight: "600", lineHeight: "30px", marginBottom: "50px", textAlign: "justify" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>Your elementary age child</span> has a strong drive for social connection. He is starting to develop deeper friendships and a connection to the community around him. Instead, we embrace your child’s natural need for social exploration by giving lessons in small groups and encouraging children to work with a variety of others on follow up projects and research into subjects of intense interest.</p>
                        <p style={{ fontWeight: "600", lineHeight: "30px", marginBottom: "50px", textAlign: "justify" }}><span style={{ background: "#ff8843a5", paddingLeft: "5px" }}>The starting point</span> for all courses of study is the “Great Lessons;” these impressionistic and scientific stories give your child the “big picture” of astronomy, earth science, geography, physics, biology, history, anthropology, cultural and social studies, language, math, music and art. Meaningful learning happens when children understand the “why” as much as the “what”— and are inspired to learn even more on their own.</p>
                    </div>
                    <button className="start-btn" style={{ marginTop: "80px" }} onClick={() => window.open("https://api.whatsapp.com/send?phone=919246182801&text=" + encodeURIComponent("Hello, I want to enquire for admissions \uD83D\uDCDA"), "_blank")} >Enroll Now <i className="fa-solid fa-arrow-up"></i></button>
                </div>
                <div className="about-s2-2">
                    <div className="pi-elementary">

                    </div>
                </div>

            </div>

        </div>

        <Footer />

    </>)

}

export default ElementaryProgram;